var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_1018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33414 9.83935V2.33348C9.33414 1.8915 9.15856 1.46762 8.84604 1.1551C8.53351 0.842568 8.10963 0.666992 7.66765 0.666992C7.22567 0.666992 6.80179 0.842568 6.48926 1.1551C6.17674 1.46762 6.00116 1.8915 6.00116 2.33348V9.83935C5.46607 10.1969 5.06014 10.717 4.84333 11.3229C4.62652 11.9288 4.61032 12.5884 4.79713 13.2043C4.98393 13.8201 5.36384 14.3595 5.88073 14.7429C6.39763 15.1262 7.02411 15.3332 7.66765 15.3332C8.31119 15.3332 8.93767 15.1262 9.45457 14.7429C9.97146 14.3595 10.3514 13.8201 10.5382 13.2043C10.725 12.5884 10.7088 11.9288 10.492 11.3229C10.2752 10.717 9.86923 10.1969 9.33414 9.83935Z",
    stroke: "#EA6C52",
    strokeWidth: 1.33319
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_1018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9983,
    height: 15.9983,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemp);
export default __webpack_public_path__ + "static/media/temp.39b79c9dc3381133abd1a18a3e9fd843.svg";
export { ForwardRef as ReactComponent };